import { render, staticRenderFns } from "./UpgradeLink.vue?vue&type=template&id=6a75fb47&"
import script from "./UpgradeLink.vue?vue&type=script&lang=js&"
export * from "./UpgradeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports